(function () {
  'use strict';

  var assistantScript = document.currentScript || document.querySelector('script[src*="fk-assistant.js"]');

  function onReady(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\b([a-z])\s*\.\s*([a-z])\s*\.?/g, '$1$2')
      .replace(/whizzler|whizzla|wizla/g, 'wizzla')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function isLocalPreview() {
    return /127\.0\.0\.1|localhost/.test(window.location.hostname) || window.location.pathname.indexOf('/clickthrough') !== -1;
  }

  function route(name) {
    var local = {
      shop: '#/shop',
      merch: '#/merch',
      cart: '#/cart',
      locator: '#/store-locator',
      rewards: '#/rewards',
      rewardsShop: '#/rewards-shop',
      wholesale: '#/wholesale',
      contact: '#/contact'
    };
    var shopify = {
      shop: '/collections/all',
      merch: '/collections/merch',
      cart: '/cart',
      locator: '/pages/store-locator',
      rewards: '/pages/rewards',
      rewardsShop: '/pages/rewards#shop',
      wholesale: '/pages/us-distributors',
      contact: '/pages/contact-us'
    };
    return (isLocalPreview() ? local : shopify)[name];
  }

  function isOrderRoute() {
    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    return path === '/cart' || path.indexOf('/checkout') === 0 || /#\/cart(?:[/?]|$)/.test(window.location.hash);
  }

  function actionLink(label, name) {
    return '<a class="fk-assistant__link" href="' + escapeHtml(route(name)) + '">' + escapeHtml(label) + '</a>';
  }

  function catalog() {
    return window.FrontoKingCatalog || { categories: [], products: [] };
  }

  function stores() {
    return Array.isArray(window.FrontoKingPublicStores) ? window.FrontoKingPublicStores : [];
  }

  function referralApiBase() {
    return String((assistantScript && assistantScript.dataset.fkReferralApiBase) || '').replace(/\/+$/, '');
  }

  var CHAT_BRAND = 'fronto-king';
  var CHAT_SESSION_KEY = 'fk_chat_intelligence_session';
  var chatEventQueue = Promise.resolve();
  var chatEventSequence = 0;

  function chatSessionId() {
    try {
      var stored = window.sessionStorage.getItem(CHAT_SESSION_KEY);
      if (stored) return stored;
      var created = 'fk-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
      window.sessionStorage.setItem(CHAT_SESSION_KEY, created);
      return created;
    } catch (error) {
      return 'fk-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
    }
  }

  function chatSource() {
    return window.location.origin + window.location.pathname;
  }

  function chatAttribution() {
    var params = new URLSearchParams(window.location.search);
    var values = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid', 'ttclid'].forEach(function (key) {
      if (params.get(key)) values[key] = params.get(key).slice(0, 200);
    });
    if (document.referrer) {
      try {
        var referrer = new URL(document.referrer);
        values.referrer_host = referrer.hostname;
        values.referrer_path = referrer.pathname;
      } catch (error) {}
    }
    return values;
  }

  function chatIntent(message) {
    var value = normalize(message);
    if (/\b(mold|mould|mildew|fungus|fuzzy|damaged|complaint|stale|dry|broken|product issue|problem with)\b/.test(value)) return 'product_issue';
    if (isDistributorIntent(message)) return 'distributor';
    if (/\b(wholesale|retailer account|stock my store|carry your|case pricing|business pricing|buyer|reseller|supplier|partnership)\b/.test(value)) return 'wholesale';
    if (/\b(real person|human|contact the team|talk to someone|sales team|customer service|need support)\b/.test(value)) return 'sales_lead';
    if (isStoreIntent(message)) return 'location';
    if (/\b(reward|points|redeem|code|membership)\b/.test(value)) return 'rewards';
    if (/\b(merch|hoodie|shirt|tray|grinder|bag)\b/.test(value)) return 'merch';
    if (/\b(product|leaf|cigar|cigarillo|crush|wrap)\b/.test(value)) return 'product';
    return 'general';
  }

  function isLeadIntent(intent) {
    return ['product_issue', 'distributor', 'wholesale', 'sales_lead'].indexOf(intent) !== -1;
  }

  function trackChatEvent(eventType, detail) {
    var base = referralApiBase();
    if (!base) return Promise.resolve(null);
    detail = detail || {};
    chatEventSequence += 1;
    var payload = {
      sessionId: chatSessionId(),
      clientEventId: 'fk-event-' + Date.now().toString(36) + '-' + chatEventSequence + '-' + Math.random().toString(36).slice(2, 8),
      eventType: eventType,
      occurredAt: new Date().toISOString(),
      source: chatSource(),
      pagePath: window.location.pathname,
      intent: detail.intent || null,
      text: detail.text || null,
      meta: detail.meta || {},
      attribution: chatAttribution()
    };
    chatEventQueue = chatEventQueue.then(function () {
      return fetch(base + '/api/' + CHAT_BRAND + '/chat/events', {
        method: 'POST',
        credentials: 'omit',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).catch(function () { return null; });
    });
    return chatEventQueue;
  }

  function categoryById(id) {
    return catalog().categories.find(function (category) { return category.id === id; });
  }

  function categorySummary() {
    return '<p>Fronto King currently has ' + catalog().products.length + ' products:</p><ul>' + catalog().categories.map(function (category) {
      var count = catalog().products.filter(function (product) { return product.category === category.id; }).length;
      return '<li><strong>' + escapeHtml(category.label) + ':</strong> ' + count + '</li>';
    }).join('') + '</ul>' + actionLink('Browse the full catalog', 'shop');
  }

  function productMatches(message) {
    var ignored = ['a', 'an', 'and', 'about', 'are', 'can', 'carry', 'do', 'does', 'for', 'fronto', 'have', 'i', 'is', 'king', 'me', 'of', 'please', 'product', 'products', 'sell', 'tell', 'the', 'there', 'what', 'which', 'with', 'you'];
    var tokens = normalize(message).split(' ').filter(function (token) {
      return token.length > 1 && ignored.indexOf(token) === -1;
    });
    if (!tokens.length) return [];
    return catalog().products.map(function (product) {
      var haystack = normalize(product.name + ' ' + (categoryById(product.category) || {}).label + ' ' + product.format + ' ' + product.description);
      var matched = tokens.filter(function (token) { return haystack.indexOf(token) !== -1; });
      return { product: product, score: matched.length, complete: matched.length === tokens.length };
    }).filter(function (entry) {
      return entry.complete || entry.score >= Math.min(2, tokens.length);
    }).sort(function (a, b) {
      return b.score - a.score || a.product.name.localeCompare(b.product.name);
    }).slice(0, 5).map(function (entry) { return entry.product; });
  }

  function productAnswer(message) {
    var matches = productMatches(message);
    if (!matches.length) return categorySummary();
    return '<p>Here are the closest Fronto King catalog matches:</p><div class="fk-assistant__results">' + matches.map(function (product) {
      var category = categoryById(product.category);
      return '<article><strong>' + escapeHtml(product.name) + '</strong><span>' + escapeHtml(category ? category.label : 'Fronto King') + '</span><small>' + escapeHtml(product.description || 'Retail selection varies by location.') + '</small><a href="' + escapeHtml(route('locator')) + '">Find near you</a></article>';
    }).join('') + '</div>' + actionLink('See all products', 'shop');
  }

  function searchableStore(store) {
    return normalize([store.name, store.address, store.city, store.state, store.postal, store.country].filter(Boolean).join(' '));
  }

  function locationAlias(message) {
    var cleaned = normalize(message);
    var result = { cleaned: cleaned, label: '', regionCities: [], regionStates: [], ambiguous: '' };
    var regions = [
      { pattern: /\bbay area\b/, label: 'the Bay Area', states: ['ca'], cities: ['oakland', 'san francisco', 'san jose', 'berkeley', 'richmond', 'hayward', 'fremont', 'san mateo', 'redwood city', 'palo alto', 'vallejo'] },
      { pattern: /\b(?:south florida|soflo)\b/, label: 'South Florida', states: ['fl'], cities: ['miami', 'north miami beach', 'fort lauderdale', 'lauderdale lakes', 'lauderhill', 'tamarac', 'sunrise', 'plantation', 'oakland park', 'margate', 'north lauderdale', 'hollywood', 'pompano beach'] },
      { pattern: /\b(?:southern california|socal)\b/, label: 'Southern California', states: ['ca'], cities: ['los angeles', 'riverside', 'el cajon', 'san diego', 'long beach', 'anaheim', 'santa ana'] },
      { pattern: /\b(?:northern california|norcal)\b/, label: 'Northern California', states: ['ca'], cities: ['oakland', 'san francisco', 'san jose', 'berkeley', 'sacramento', 'fresno', 'stockton'] },
      { pattern: /\b(?:dmv|dc metro)\b/, label: 'the DMV', states: ['dc', 'md', 'va'], cities: [] },
      { pattern: /\bnyc\b/, label: 'New York City', states: ['ny'], cities: ['new york', 'brooklyn', 'bronx', 'queens', 'staten island'] }
    ];
    regions.some(function (region) {
      if (!region.pattern.test(cleaned)) return false;
      result.label = region.label;
      result.regionCities = region.cities;
      result.regionStates = region.states;
      result.cleaned = cleaned.replace(region.pattern, ' ');
      return true;
    });
    result.cleaned = result.cleaned
      .replace(/\bvegas\b/g, 'las vegas nv')
      .replace(/\bcali\b/g, 'ca')
      .replace(/\bphilly\b/g, 'philadelphia pa')
      .replace(/\batl\b/g, 'atlanta ga');
    if (!result.label && /\bla\b/.test(result.cleaned) && !/\blos angeles\b|\blouisiana\b/.test(result.cleaned)) {
      result.ambiguous = 'LA';
    }
    return result;
  }

  function storeQuery(message) {
    var stateNames = {
      alabama: 'al', alaska: 'ak', arizona: 'az', arkansas: 'ar', california: 'ca', colorado: 'co', connecticut: 'ct', delaware: 'de', florida: 'fl', georgia: 'ga',
      hawaii: 'hi', idaho: 'id', illinois: 'il', indiana: 'in', iowa: 'ia', kansas: 'ks', kentucky: 'ky', louisiana: 'la', maine: 'me', maryland: 'md',
      massachusetts: 'ma', michigan: 'mi', minnesota: 'mn', mississippi: 'ms', missouri: 'mo', montana: 'mt', nebraska: 'ne', nevada: 'nv',
      'new hampshire': 'nh', 'new jersey': 'nj', 'new mexico': 'nm', 'new york': 'ny', 'north carolina': 'nc', 'north dakota': 'nd', ohio: 'oh',
      oklahoma: 'ok', oregon: 'or', pennsylvania: 'pa', 'rhode island': 'ri', 'south carolina': 'sc', 'south dakota': 'sd', tennessee: 'tn',
      texas: 'tx', utah: 'ut', vermont: 'vt', virginia: 'va', washington: 'wa', 'west virginia': 'wv', wisconsin: 'wi', wyoming: 'wy',
      'district of columbia': 'dc', jamaica: 'jamaica'
    };
    var stateCodes = {};
    Object.keys(stateNames).forEach(function (name) { stateCodes[stateNames[name]] = true; });
    var original = String(message || '');
    var alias = locationAlias(original);
    var cleaned = alias.cleaned;
    var stateNameCode = '';
    Object.keys(stateNames).sort(function (a, b) { return b.length - a.length; }).forEach(function (name) {
      var matcher = new RegExp('\\b' + name.replace(/ /g, '\\s+') + '\\b', 'g');
      if (matcher.test(cleaned)) stateNameCode = stateNameCode || stateNames[name];
      cleaned = cleaned.replace(matcher, stateNames[name]);
    });
    var filler = ['a', 'address', 'any', 'are', 'around', 'at', 'away', 'buy', 'by', 'can', 'close', 'closest', 'current', 'do', 'find', 'for', 'from', 'fronto', 'get', 'i', 'in', 'is', 'king', 'list', 'located', 'location', 'locations', 'look', 'looking', 'me', 'mi', 'mile', 'miles', 'my', 'near', 'nearby', 'or', 'outlet', 'outlets', 'please', 'retail', 'retailer', 'retailers', 'shop', 'shops', 'show', 'some', 'store', 'stores', 'tell', 'the', 'there', 'to', 'type', 'typed', 'use', 'where', 'within', 'you', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'fifteen', 'twenty', 'twentyfive', 'thirty', 'fifty'];
    var rawTokens = cleaned.split(' ').filter(Boolean);
    var uppercaseCode = original.match(/(?:^|[^A-Za-z])([A-Z])\.?\s*([A-Z])\.?(?=$|[^A-Za-z])/);
    var explicitCode = uppercaseCode ? normalize(uppercaseCode[1] + uppercaseCode[2]) : '';
    var stateCode = alias.regionStates.length ? '' : stateNameCode || (stateCodes[explicitCode] ? explicitCode : '') || rawTokens.find(function (token) {
      return stateCodes[token] && filler.indexOf(token) === -1;
    }) || '';
    var placeTokens = [];
    rawTokens.forEach(function (token) {
      if (filler.indexOf(token) !== -1 || stateCodes[token] || /^\d+$/.test(token)) return;
      if (placeTokens.indexOf(token) === -1) placeTokens.push(token);
    });
    return {
      cleaned: cleaned,
      zip: (cleaned.match(/\b\d{5}\b/) || [])[0] || '',
      stateCode: stateCode,
      placeTokens: placeTokens,
      placePhrase: placeTokens.join(' '),
      regionCities: alias.regionCities,
      regionStates: alias.regionStates,
      aliasLabel: alias.label,
      ambiguousLocation: alias.ambiguous,
      hasExplicitPlace: Boolean(stateCode || placeTokens.length || alias.regionStates.length || /\b\d{5}\b/.test(cleaned))
    };
  }

  function storeStateCode(store) {
    var state = normalize(store.state);
    var longNames = {
      florida: 'fl', maryland: 'md', georgia: 'ga', 'new york': 'ny', pennsylvania: 'pa', texas: 'tx', virginia: 'va', louisiana: 'la',
      massachusetts: 'ma', missouri: 'mo', nevada: 'nv', 'north carolina': 'nc', 'south carolina': 'sc', 'district of columbia': 'dc'
    };
    if (longNames[state]) return longNames[state];
    if (/^[a-z]{2}$/.test(state)) return state;
    return normalize(store.country) === 'jamaica' ? 'jamaica' : state;
  }

  function storeMatches(message) {
    var query = storeQuery(message);
    return stores().map(function (store) {
      var haystack = searchableStore(store);
      var storeState = storeStateCode(store);
      var stateMatch = query.regionStates.length ? query.regionStates.indexOf(storeState) !== -1 : !query.stateCode || storeState === query.stateCode;
      var postalMatch = !query.zip || String(store.postal || '').indexOf(query.zip) === 0;
      var matchedTokens = query.placeTokens.filter(function (token) { return haystack.indexOf(token) !== -1; });
      var city = normalize(store.city);
      var regionMatch = !query.regionCities.length || query.regionCities.some(function (regionCity) {
        return city === regionCity || city.indexOf(regionCity) !== -1 || haystack.indexOf(regionCity) !== -1;
      });
      var score = matchedTokens.length * 4;
      if (query.placePhrase && city === query.placePhrase) score += 20;
      else if (query.placePhrase && city.indexOf(query.placePhrase) !== -1) score += 12;
      if (query.placePhrase && haystack.indexOf(query.placePhrase) !== -1) score += 7;
      if (query.zip && postalMatch) score += 25;
      if (query.stateCode && stateMatch) score += 3;
      if (query.regionStates.length && stateMatch) score += 4;
      if (query.regionCities.length && regionMatch) score += 18;
      return { store: store, score: score, matchedTokens: matchedTokens.length, stateMatch: stateMatch, postalMatch: postalMatch, regionMatch: regionMatch };
    }).filter(function (entry) {
      if (!entry.stateMatch || !entry.postalMatch || !entry.regionMatch) return false;
      if (query.placeTokens.length && entry.matchedTokens < Math.min(2, query.placeTokens.length)) return false;
      return entry.score > 0;
    }).sort(function (a, b) {
      return b.score - a.score || a.store.name.localeCompare(b.store.name);
    }).slice(0, 4).map(function (entry) { return entry.store; });
  }

  function directionsUrl(store) {
    var address = store.address || [store.city, store.state, store.postal, store.country].filter(Boolean).join(', ');
    return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(address);
  }

  function storeAnswer(message) {
    var text = normalize(message);
    var query = storeQuery(message);
    if (query.ambiguousLocation) {
      return '<p>When you say <strong>LA</strong>, do you mean Los Angeles, California, or Louisiana?</p>';
    }
    if (/\b(?:\d+|one|two|three|four|five|six|seven|eight|nine|ten|fifteen|twenty|twenty five|thirty|fifty)\s*(?:miles?|mi)\b/.test(text) || /\bnear me\b|\bmy location\b|\bcurrent location\b|\buse my location\b/.test(text)) {
      return '<p>Use the Fronto King Store Locator for current-location and strict distance searches. It will not show stores outside the radius you choose.</p>' + actionLink('Open Store Locator', 'locator');
    }
    if (!query.hasExplicitPlace) {
      return '<p>What city, state, region, or ZIP should I search for approved Fronto King retailers?</p>' + actionLink('Use My Location in Store Locator', 'locator');
    }
    var matches = storeMatches(message);
    if (!matches.length) {
      return '<p>I do not see an approved public retailer matching that area yet. What nearby city, state, or ZIP should I check instead?</p>' + actionLink('Open Store Locator', 'locator');
    }
    var area = query.aliasLabel ? ' for ' + escapeHtml(query.aliasLabel) : '';
    return '<p>I found approved public retailers' + area + '. Product selection can vary, so contact the store before visiting.</p><div class="fk-assistant__stores">' + matches.map(function (store) {
      var address = store.address || [store.city, store.state, store.postal, store.country].filter(Boolean).join(', ');
      var phone = store.phone ? '<a href="tel:' + escapeHtml(store.phone.replace(/[^+\d]/g, '')) + '">Call</a>' : '';
      return '<article><strong>' + escapeHtml(store.name) + '</strong><small>' + escapeHtml(address) + '</small><span><a href="' + escapeHtml(directionsUrl(store)) + '" target="_blank" rel="noopener noreferrer">Directions</a>' + phone + '</span></article>';
    }).join('') + '</div>' + actionLink('Search the full retailer directory', 'locator');
  }

  function isDistributorIntent(message) {
    var text = normalize(message);
    return /\b(distributor|distributors|distro|distros|distribution partner|who distributes|find a distributor|need a distributor|supplier for my store|supply my store)\b/.test(text);
  }

  function isStoreIntent(message) {
    var text = normalize(message);
    if (/\b(store|stores|retail|retailer|retailers|shop|shops|outlet|outlets|location|locations|located|near me|my location|current location|use my location|where can i buy|zip|closest|nearest|nearby|carry|carries|stocked|sold)\b/.test(text) || /\b\d{5}\b/.test(text)) return true;
    var query = storeQuery(message);
    if (query.aliasLabel || query.stateCode || query.regionStates.length || query.ambiguousLocation) return true;
    return query.hasExplicitPlace && text.split(' ').length <= 6 && storeMatches(message).length > 0;
  }

  function distributorReferralForm() {
    return '<p>I can send a distributor-referral request to Hustle Van for review. This does not guarantee a distributor, territory, product availability, pricing, an order, or shipment.</p>' +
      '<form class="fk-referral-form" data-fk-referral-form novalidate>' +
        '<label><span>Business or store name</span><input name="businessName" type="text" maxlength="160" autocomplete="organization" required></label>' +
        '<label><span>Market or store location</span><input name="market" type="text" maxlength="200" autocomplete="address-level2" placeholder="City, state, or ZIP" required></label>' +
        '<label><span>Contact name</span><input name="contactName" type="text" maxlength="160" autocomplete="name" required></label>' +
        '<label><span>Phone or WhatsApp</span><input name="phone" type="tel" maxlength="40" autocomplete="tel" required></label>' +
        '<label><span>Email</span><input name="email" type="email" maxlength="254" autocomplete="email" required></label>' +
        '<label><span>Products or request details <small>(optional)</small></span><textarea name="notes" maxlength="1000" rows="3"></textarea></label>' +
        '<label class="fk-referral-form__honeypot" aria-hidden="true">Website<input name="website" type="text" tabindex="-1" autocomplete="off"></label>' +
        '<label class="fk-referral-form__confirm"><input name="reviewAcknowledged" type="checkbox" required><span>I understand this is a request for manual referral review.</span></label>' +
        '<button type="submit">Send distributor request</button>' +
        '<span class="fk-referral-form__status" data-fk-referral-status aria-live="polite"></span>' +
      '</form>';
  }

  function moldAnswer() {
    return '<p>I am sorry you found something concerning on the leaf.</p>' +
      '<p><strong>Do not smoke or use it</strong> if you see fuzzy growth, spreading spots, dampness, or an unusual odor. A dry line or light discoloration limited to the center vein can be natural leaf variation, but do not wipe suspected mold away and then use the leaf. If you are unsure, stop using it.</p>' +
      '<p>Keep the package and lot details, take clear photos, and return it to the retailer or contact Fronto King. We keep natural-leaf processing minimal, so normal color and vein variation can occur; visible mold is not acceptable.</p>' + actionLink('Contact Fronto King', 'contact');
  }

  function answer(message) {
    var text = normalize(message);
    if (!text) return '<p>Ask me about Fronto King products, stores, merch, rewards, wholesale, or product support.</p>';
    if (/\b(mold|mould|mildew|fungus|fuzzy|fuzz|white spots?|green spots?|black spots?)\b/.test(text)) return moldAnswer();
    if (isDistributorIntent(message)) return '<p>I can send your distributor or wholesale request privately to Hustle Van Sales for review. Start with your email below; delivery does not guarantee territory, pricing, product availability, an order, or shipment.</p>';
    if (/\b(wholesale|distribution|retailer account|stock my store|carry your|cases|case pricing|business pricing|smoke shop|buyer|reseller|supplier|partnership)\b/.test(text)) {
      return '<p>Licensed retailers and distributors can send their business request privately to Hustle Van Sales for review. Start with your email below. Submission does not guarantee pricing, territory, approval, or inventory.</p>';
    }
    if (isStoreIntent(message)) return storeAnswer(message);
    if (/\b(merch|hoodie|hoodies|shirt|shirts|tee|tees|tray|trays|grinder|grinders|bag|bags|apparel|gear)\b/.test(text)) {
      return '<p>Rolling with Fronto includes the 300-point signature hoodie, 150-point Dark Crush T-shirt, 100-point rolling tray, 120-point grinder, and 100-point drawstring bag. Sign in to Fronto King Rewards to see current owned-stock availability.</p>' + actionLink('See Fronto King merch', 'merch');
    }
    if (/\b(issue|problem|damaged|complaint|support|wrong|stale|dry|broken)\b/.test(text)) {
      return '<p>For product support, keep the package and send the product name, retailer, city/state, photos, lot or package details, and what happened through Contact.</p>' + actionLink('Contact Fronto King', 'contact');
    }
    if (/\b(reward|rewards|points|code|codes|member|membership|redeem)\b/.test(text)) {
      return '<p>Fronto King Rewards is a separate 21+ member program for approved package codes, points, activity, and company-controlled merch rewards.</p>' + actionLink('Explore Fronto King Rewards', 'rewards');
    }
    if (/\b(order|orders|cart|checkout|purchase|buy online|shipping|submit)\b/.test(text)) {
      return '<p>Online consumer ordering is not open yet. Use the Store Locator for retail products. Licensed retailers and distributors can use the Wholesale page.</p>' + actionLink('Find a retailer', 'locator') + actionLink('Open Wholesale', 'wholesale');
    }
    if (/\b(product|products|catalog|leaf|cigar|cigars|cigarillo|cigarillos|crush|wrap|wraps|wizzla|natural|smooth|dark cuts|flavor|flavors|banana|berry|chocolate|cognac|grape|honey|mango|mint|pineapple|strawberry|sweet|vanilla)\b/.test(text)) return productAnswer(message);
    if (/\b(hello|hi|hey|good morning|good afternoon|good evening)\b/.test(text)) {
      return '<p>Welcome to Fronto King. Ask me about the 30-product catalog, finding a retailer, merch, rewards, wholesale, or support.</p>';
    }
    return '<p>Are you looking for a Fronto King product, a retail store, a distributor, rewards, merch, or product support?</p>' + actionLink('Browse Fronto King products', 'shop');
  }

  if (isLocalPreview()) window.FrontoKingAssistantQA = { answer: answer, storeMatches: storeMatches, storeQuery: storeQuery, isStoreIntent: isStoreIntent, isDistributorIntent: isDistributorIntent };

  onReady(function () {
    document.body.insertAdjacentHTML('beforeend',
      '<div class="fk-assistant" data-fk-assistant>' +
        '<button class="fk-assistant__toggle" type="button" aria-expanded="false" aria-controls="FkAssistantPanel"><span aria-hidden="true">FK</span><strong>Ask Fronto King</strong></button>' +
        '<section id="FkAssistantPanel" class="fk-assistant__panel" aria-label="Ask Fronto King" hidden>' +
          '<header><div><strong>Ask Fronto King</strong><span>Products, stores, merch, and support</span></div><button type="button" data-fk-assistant-close aria-label="Close chat" title="Close">&times;</button></header>' +
          '<div class="fk-assistant__messages" data-fk-assistant-messages aria-live="polite"></div>' +
          '<form class="fk-assistant__form" data-fk-assistant-form>' +
            '<label class="visually-hidden" for="FkAssistantInput">Ask Fronto King a question</label>' +
            '<input id="FkAssistantInput" name="message" type="text" autocomplete="off" placeholder="Ask a Fronto King question" required>' +
            '<button class="fk-assistant__voice" type="button" data-fk-assistant-voice aria-label="Dictate question" aria-pressed="false" title="Dictate question"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><path d="M12 19v3"></path></svg></button>' +
            '<button class="fk-assistant__send" type="submit" aria-label="Send question" title="Send">&#8593;</button>' +
            '<span class="fk-assistant__voice-status" data-fk-assistant-voice-status aria-live="polite" hidden></span>' +
          '</form>' +
          '<p class="fk-assistant__privacy">Approved public retailer information. Distributor requests are sent privately to Hustle Van for review.</p>' +
        '</section>' +
      '</div>');

    var root = document.querySelector('[data-fk-assistant]');
    var toggle = root.querySelector('.fk-assistant__toggle');
    var panel = root.querySelector('.fk-assistant__panel');
    var messages = root.querySelector('[data-fk-assistant-messages]');
    var form = root.querySelector('[data-fk-assistant-form]');
    var input = form.querySelector('input');
    var voiceButton = root.querySelector('[data-fk-assistant-voice]');
    var voiceStatus = root.querySelector('[data-fk-assistant-voice-status]');
    var recognition = null;
    var listening = false;
    var voiceSeed = '';
    var heardVoice = false;
    var initialReplyTracked = false;
    var activeLead = null;
    var leadAbandonedTracked = false;

    function addMessage(role, html, options) {
      messages.insertAdjacentHTML('beforeend', '<div class="fk-assistant__message fk-assistant__message--' + role + '">' + html + '</div>');
      messages.scrollTop = messages.scrollHeight;
      var node = messages.lastElementChild;
      if (!options || options.track !== false) {
        trackChatEvent(role === 'user' ? 'chat_message' : 'chat_reply', {
          intent: options && options.intent || null,
          text: options && options.text || (node ? node.textContent : '')
        });
      }
      return node;
    }

    function referralFallbackLink(referral) {
      return 'mailto:info@hustlevan.com?subject=' + encodeURIComponent('Fronto King website chat follow-up');
    }

    function maskEmail(value) {
      var parts = String(value || '').split('@');
      if (parts.length !== 2) return 'your email';
      return parts[0].slice(0, 1) + '***@' + parts[1];
    }

    function leadEmailForm(intent, originalQuestion) {
      activeLead = {
        intent: intent,
        originalQuestion: originalQuestion,
        startedAt: new Date().toISOString(),
        submitted: false
      };
      leadAbandonedTracked = false;
      trackChatEvent('chat_lead_started', { intent: intent });
      var purpose = intent === 'product_issue' ? 'product-support' : 'sales';
      addMessage('bot',
        '<p>Would you like the Fronto King ' + purpose + ' team to follow up? Start with your email.</p>' +
        '<form class="fk-referral-form" data-fk-lead-email novalidate>' +
          '<label><span>Email</span><input name="email" type="email" maxlength="254" autocomplete="email" required></label>' +
          '<label class="fk-referral-form__honeypot" aria-hidden="true">Website<input name="website" type="text" tabindex="-1" autocomplete="off"></label>' +
          '<button type="submit">Continue</button>' +
          '<span class="fk-referral-form__status" data-fk-lead-status aria-live="polite"></span>' +
        '</form>',
        { intent: intent, text: 'Would you like the Fronto King team to follow up? Start with your email.' }
      );
    }

    function leadDetailsForm(container, email) {
      activeLead.email = email;
      trackChatEvent('chat_lead_email_entered', { intent: activeLead.intent });
      container.outerHTML =
        '<form class="fk-referral-form" data-fk-lead-details novalidate>' +
          '<p>Thanks. Add anything that will help the team respond. These details are optional except consent.</p>' +
          '<label><span>Contact name <small>(optional)</small></span><input name="contactName" type="text" maxlength="160" autocomplete="name"></label>' +
          '<label><span>Business or store <small>(optional)</small></span><input name="businessName" type="text" maxlength="160" autocomplete="organization"></label>' +
          '<label><span>Market or location <small>(optional)</small></span><input name="market" type="text" maxlength="200" autocomplete="address-level2" placeholder="City, state, or ZIP"></label>' +
          '<label><span>Phone or WhatsApp <small>(optional)</small></span><input name="phone" type="tel" maxlength="40" autocomplete="tel"></label>' +
          '<label class="fk-referral-form__confirm"><input name="consent" type="checkbox" required><span>I agree that Hustle Van may use these details to respond to this request.</span></label>' +
          '<button type="submit">Send private request</button>' +
          '<span class="fk-referral-form__status" data-fk-lead-status aria-live="polite"></span>' +
        '</form>';
    }

    async function submitChatLead(detailsForm) {
      if (!detailsForm.checkValidity()) {
        detailsForm.reportValidity();
        return;
      }
      var fields = new FormData(detailsForm);
      var button = detailsForm.querySelector('button[type="submit"]');
      var status = detailsForm.querySelector('[data-fk-lead-status]');
      var consentAt = new Date().toISOString();
      var payload = {
        brand: CHAT_BRAND,
        sessionId: chatSessionId(),
        email: activeLead.email,
        phone: String(fields.get('phone') || '').trim(),
        contactName: String(fields.get('contactName') || '').trim(),
        businessName: String(fields.get('businessName') || '').trim(),
        market: String(fields.get('market') || '').trim(),
        originalQuestion: activeLead.originalQuestion,
        intent: activeLead.intent,
        source: chatSource(),
        pagePath: window.location.pathname,
        attribution: chatAttribution(),
        consent: fields.get('consent') === 'on',
        consentAt: consentAt,
        leadStartedAt: activeLead.startedAt,
        submittedAt: consentAt,
        website: ''
      };
      button.disabled = true;
      status.textContent = 'Saving and delivering your request...';
      try {
        var response = await fetch(referralApiBase() + '/api/' + CHAT_BRAND + '/chat/leads', {
          method: 'POST',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        var result = await response.json().catch(function () { return {}; });
        if (!response.ok || !result.ok || !result.data || !result.data.referenceId) throw new Error('Lead request failed.');
        activeLead.submitted = true;
        var delivery = result.data.deliveryStatus === 'verified'
          ? 'Saved and delivered to Hustle Van Sales for review.'
          : 'Saved, but the Sales notification is queued and not yet verified.';
        detailsForm.outerHTML = '<div class="fk-referral-form__success"><strong>' + escapeHtml(delivery) + '</strong><span>Reference ' + escapeHtml(result.data.referenceId) + '</span><small>Confirmation: ' + escapeHtml(maskEmail(activeLead.email)) + '. Delivery does not mean assigned, contacted, approved, priced, ordered, or shipped.</small></div>';
      } catch (error) {
        button.disabled = false;
        status.innerHTML = 'The private request could not be verified. Try again, or <a href="mailto:info@hustlevan.com?subject=Fronto%20King%20website%20chat%20follow-up">email Hustle Van</a>. The email link does not include your form details.';
        trackChatEvent('chat_lead_failed', { intent: activeLead.intent, meta: { failure_code: 'browser_submission_failed' } });
      }
    }

    function trackLeadAbandonment() {
      if (!activeLead || activeLead.submitted || leadAbandonedTracked) return;
      leadAbandonedTracked = true;
      trackChatEvent('chat_lead_abandoned', { intent: activeLead.intent });
    }

    async function submitDistributorReferral(referralForm) {
      if (!referralForm.checkValidity()) {
        referralForm.reportValidity();
        return;
      }
      var fields = new FormData(referralForm);
      var referral = {
        brand: 'fronto-king',
        source: window.location.href,
        submittedAt: new Date().toISOString(),
        businessName: String(fields.get('businessName') || '').trim(),
        market: String(fields.get('market') || '').trim(),
        contactName: String(fields.get('contactName') || '').trim(),
        phone: String(fields.get('phone') || '').trim(),
        email: String(fields.get('email') || '').trim(),
        notes: String(fields.get('notes') || '').trim(),
        website: String(fields.get('website') || '').trim(),
        reviewAcknowledged: fields.get('reviewAcknowledged') === 'on'
      };
      var status = referralForm.querySelector('[data-fk-referral-status]');
      var submit = referralForm.querySelector('button[type="submit"]');
      var base = referralApiBase();
      submit.disabled = true;
      status.textContent = 'Sending request...';
      try {
        if (!base) throw new Error('Distributor request service is not configured.');
        var response = await fetch(base + '/api/fronto-king/distributor-referrals', {
          method: 'POST',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(referral)
        });
        var payload = await response.json().catch(function () { return {}; });
        if (!response.ok || !payload.ok || !payload.data || !payload.data.requestId) throw new Error('Request delivery failed.');
        referralForm.outerHTML = '<div class="fk-referral-form__success"><strong>Request received for review.</strong><span>Reference ' + escapeHtml(payload.data.requestId) + '</span><small>Hustle Van will review the market and use the submitted contact information if follow-up is needed.</small></div>';
      } catch (error) {
        submit.disabled = false;
        status.innerHTML = 'The request could not be sent right now. <a href="' + escapeHtml(referralFallbackLink(referral)) + '">Email it to info@hustlevan.com</a>.';
      }
    }

    function setOpen(open) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) {
        trackChatEvent('chat_open', { meta: { label: 'Ask Fronto King' } });
        if (!initialReplyTracked) {
          initialReplyTracked = true;
          trackChatEvent('chat_reply', { intent: 'general', text: 'Welcome to Fronto King. Ask me about any current product, finding a retailer, merch, rewards, wholesale, or support.' });
        }
        input.focus();
      } else {
        trackLeadAbandonment();
        if (recognition && listening) recognition.abort();
      }
    }

    function setVoiceStatus(message) {
      voiceStatus.textContent = message || '';
      voiceStatus.hidden = !message;
    }

    function setListening(active) {
      listening = active;
      voiceButton.classList.toggle('is-listening', active);
      voiceButton.setAttribute('aria-pressed', String(active));
      voiceButton.setAttribute('title', active ? 'Stop listening' : 'Dictate question');
      voiceButton.setAttribute('aria-label', active ? 'Stop listening' : 'Dictate question');
    }

    function startVoiceInput() {
      var Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!Recognition) {
        setVoiceStatus('Voice input is not supported in this browser. You can still type your question.');
        return;
      }
      voiceSeed = input.value.trim();
      heardVoice = false;
      recognition = new Recognition();
      recognition.lang = 'en-US';
      recognition.continuous = false;
      recognition.interimResults = true;
      recognition.maxAlternatives = 1;
      recognition.onstart = function () {
        setListening(true);
        setVoiceStatus('Listening...');
      };
      recognition.onresult = function (event) {
        var transcript = '';
        for (var index = event.resultIndex; index < event.results.length; index += 1) {
          transcript += event.results[index][0].transcript;
          if (event.results[index].isFinal) heardVoice = true;
        }
        input.value = [voiceSeed, transcript.trim()].filter(Boolean).join(' ');
      };
      recognition.onerror = function (event) {
        var messages = {
          'not-allowed': 'Microphone permission was not approved. You can still type your question.',
          'service-not-allowed': 'Microphone permission was not approved. You can still type your question.',
          'audio-capture': 'A microphone is not available on this device.',
          'no-speech': 'I did not hear anything. Tap the microphone and try again.'
        };
        setVoiceStatus(messages[event.error] || 'Voice input stopped. Tap the microphone to try again.');
      };
      recognition.onend = function () {
        setListening(false);
        if (heardVoice) {
          setVoiceStatus('Voice captured. Review it, then send.');
          input.focus();
        } else if (voiceStatus.textContent === 'Listening...') {
          setVoiceStatus('I did not hear anything. Tap the microphone and try again.');
        }
      };
      try {
        recognition.start();
      } catch (error) {
        setListening(false);
        setVoiceStatus('Voice input could not start. Tap the microphone to try again.');
      }
    }

    function syncRouteVisibility() {
      var hidden = isOrderRoute();
      if (hidden) setOpen(false);
      root.hidden = hidden;
    }

    addMessage('bot', '<p>Welcome to Fronto King. Ask me about any current product, finding a retailer, merch, rewards, wholesale, or support.</p>', { track: false });
    toggle.addEventListener('click', function () { setOpen(panel.hidden); });
    root.querySelector('[data-fk-assistant-close]').addEventListener('click', function () { setOpen(false); toggle.focus(); });
    voiceButton.addEventListener('click', function () {
      if (recognition && listening) recognition.stop();
      else startVoiceInput();
    });
    window.addEventListener('hashchange', syncRouteVisibility);
    syncRouteVisibility();

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var message = input.value.trim();
      if (!message) return;
      var intent = chatIntent(message);
      addMessage('user', '<p>' + escapeHtml(message) + '</p>', { intent: intent, text: message });
      input.value = '';
      window.setTimeout(function () {
        addMessage('bot', answer(message), { intent: intent });
        if (isLeadIntent(intent)) leadEmailForm(intent, message);
      }, 120);
    });

    messages.addEventListener('submit', function (event) {
      var emailForm = event.target.closest('[data-fk-lead-email]');
      if (emailForm) {
        event.preventDefault();
        if (!emailForm.checkValidity()) {
          emailForm.reportValidity();
          return;
        }
        var emailFields = new FormData(emailForm);
        if (String(emailFields.get('website') || '').trim()) return;
        leadDetailsForm(emailForm, String(emailFields.get('email') || '').trim().toLowerCase());
        return;
      }
      var detailsForm = event.target.closest('[data-fk-lead-details]');
      if (detailsForm) {
        event.preventDefault();
        submitChatLead(detailsForm);
        return;
      }
      var referralForm = event.target.closest('[data-fk-referral-form]');
      if (!referralForm) return;
      event.preventDefault();
      submitDistributorReferral(referralForm);
    });

    messages.addEventListener('click', function (event) {
      var link = event.target.closest('a');
      if (!link) return;
      var label = String(link.textContent || '').trim();
      trackChatEvent('chat_quick_action', { intent: 'general', meta: { label: label.slice(0, 120) } });
      if (/google\.com\/maps/.test(link.href)) trackChatEvent('directions_click', { intent: 'location', meta: { label: label.slice(0, 120) } });
      if (link.protocol === 'tel:') trackChatEvent('store_phone_click', { intent: 'location', meta: { label: label.slice(0, 120) } });
    });

    document.addEventListener('submit', function (event) {
      var locatorForm = event.target.closest && event.target.closest('[data-frk-locator-form]');
      if (!locatorForm) return;
      window.setTimeout(function () {
        var query = locatorForm.querySelector('[name="query"]');
        var results = document.querySelectorAll('[data-frk-locator-list] article').length;
        trackChatEvent('locator_search', {
          intent: 'location',
          text: query ? query.value : '',
          meta: { result_count: results, radius_miles: String((locatorForm.querySelector('[name="radius"]') || {}).value || '') }
        });
      }, 300);
    }, true);

    document.addEventListener('click', function (event) {
      var target = event.target.closest && event.target.closest('button,a,article');
      if (!target) return;
      if (target.matches('[data-frk-use-location]')) trackChatEvent('locator_use_location', { intent: 'location' });
      if (target.matches('[data-frk-reset]')) trackChatEvent('locator_reset', { intent: 'location' });
      if (target.closest('[data-frk-locator-list]')) {
        var store = target.closest('article');
        var name = store ? String((store.querySelector('strong,b') || {}).textContent || '').trim() : '';
        if (target.matches('a[href*="google.com/maps"]')) trackChatEvent('directions_click', { intent: 'location', meta: { store_name: name } });
        else if (target.matches('a[href^="tel:"]')) trackChatEvent('store_phone_click', { intent: 'location', meta: { store_name: name } });
        else if (store) trackChatEvent('locator_result_click', { intent: 'location', meta: { store_name: name } });
      }
    }, true);

    window.addEventListener('pagehide', trackLeadAbandonment);

  });
})();
